var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFixupLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1104,
    height: 300,
    viewBox: "0 0 1104 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 33.8307H170.396V91.7901H69.1533V141.541H155.968V199.5H69.1533V295.27H0V33.8307Z",
    fill: "#FF393A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M193.78 34.5766C193.78 14.4277 209.948 0 232.336 0C254.724 0 270.893 14.4277 270.893 34.5766C270.893 54.7256 254.724 69.1533 232.336 69.1533C209.948 69.1533 193.78 54.7256 193.78 34.5766ZM197.76 94.0286H266.913V295.021H197.76V94.0286Z",
    fill: "#FF393A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M344.274 190.544L287.31 94.0284H360.941L375.368 122.137C380.592 133.331 386.313 145.52 391.537 156.714H393.03C396.761 145.52 401.487 133.331 404.97 122.137L414.671 94.0284H486.312L429.348 198.505L489.546 295.021H415.666L399.497 266.912C393.527 255.718 387.806 243.529 381.836 232.335H380.343C375.866 243.529 371.139 255.22 366.662 266.912L355.468 295.021H283.827L344.274 190.544Z",
    fill: "#FF393A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M510.69 33.8345H579.844V176.867C579.844 223.384 591.784 240.299 619.147 240.299C646.509 240.299 659.445 223.384 659.445 176.867V33.8345H726.11V168.907C726.11 258.21 692.28 300 619.147 300C546.013 300 510.69 258.21 510.69 168.907V33.8345Z",
    fill: "#36373C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M770.139 33.8345H871.381C927.599 33.8345 975.857 54.7297 975.857 120.649C975.857 184.579 926.107 212.19 871.381 212.19H839.292V295.025H770.139V33.8345ZM868.396 157.465C895.759 157.465 908.694 143.783 908.694 120.4C908.694 97.0177 894.267 88.3113 868.396 88.3113H839.541V157.465H868.396Z",
    fill: "#36373C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1024.36 225.119C1001.23 219.398 981.082 230.343 976.107 250.989C971.132 271.636 983.818 290.541 1006.95 296.262C1030.09 301.984 1050.23 291.039 1055.21 270.392C1060.43 249.497 1047.5 230.84 1024.36 225.119Z",
    fill: "#FF393A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1018.39 89.5457L1022.87 60.6904C1027.85 40.0439 1048.74 27.3575 1069.39 32.3326L1073.87 33.3276C1094.51 38.3026 1107.2 59.1979 1102.22 79.8444L1092.52 108.7L1050.48 207.455L1008.44 197.256L1018.39 89.5457Z",
    fill: "#36373C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFixupLogo);
export default __webpack_public_path__ + "static/media/FIXUP-LOGO.bc2cb830756eadb17cf19f927a60cc22.svg";
export { ForwardRef as ReactComponent };